import * as React from "react";
import * as TabsPrimitive from "@radix-ui/react-tabs";

import { cn } from "../lib/utils";

const Tabs = TabsPrimitive.Root;

const TabsList = React.forwardRef<
  React.ElementRef<typeof TabsPrimitive.List>,
  React.ComponentPropsWithoutRef<typeof TabsPrimitive.List>
>(({ className, ...props }, ref) => (
  <TabsPrimitive.List
    ref={ref}
    className={cn(
      "tw-figr-text-muted-foreground tw-figr-inline-flex tw-figr-h-10 tw-figr-items-center tw-figr-justify-center tw-figr-rounded-b-s tw-figr-rounded-t-s tw-figr-bg-neutral-200 tw-figr-p-1",
      className
    )}
    {...props}
  />
));
TabsList.displayName = TabsPrimitive.List.displayName;

const TabsTrigger = React.forwardRef<
  React.ElementRef<typeof TabsPrimitive.Trigger>,
  React.ComponentPropsWithoutRef<typeof TabsPrimitive.Trigger>
>(({ className, ...props }, ref) => (
  <TabsPrimitive.Trigger
    ref={ref}
    className={cn(
      "tw-figr-inline-flex tw-figr-items-center tw-figr-justify-center tw-figr-whitespace-nowrap tw-figr-rounded-sm tw-figr-rounded-b-s tw-figr-rounded-t-s tw-figr-px-sm tw-figr-py-xs tw-figr-text-desktop-caption-accent tw-figr-ring-offset-background tw-figr-transition-all focus-visible:tw-figr-outline-none focus-visible:tw-figr-ring-2 focus-visible:tw-figr-ring-primary focus-visible:tw-figr-ring-offset-2 disabled:tw-figr-pointer-events-none disabled:tw-figr-opacity-50 data-[state=active]:tw-figr-bg-base-white data-[state=active]:tw-figr-text-base-black data-[state=active]:tw-figr-shadow-sm",
      className
    )}
    {...props}
  />
));
TabsTrigger.displayName = TabsPrimitive.Trigger.displayName;

const TabsContent = React.forwardRef<
  React.ElementRef<typeof TabsPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof TabsPrimitive.Content>
>(({ className, ...props }, ref) => (
  <TabsPrimitive.Content
    ref={ref}
    className={cn(
      "tw-figr-mt-2 tw-figr-bg-base-white tw-figr-ring-offset-background focus-visible:tw-figr-outline-none focus-visible:tw-figr-ring-2 focus-visible:tw-figr-ring-primary focus-visible:tw-figr-ring-offset-2",
      className
    )}
    {...props}
  />
));
TabsContent.displayName = TabsPrimitive.Content.displayName;

export { Tabs, TabsList, TabsTrigger, TabsContent };
